export default {
  liveStats: {
    openVsx: { publisher: 'juanlias', name: 'ultra-instinct-theme' },
    marketplace: { publisher: 'JuanLias', name: 'ultra-instinct-theme' },
  },
  meta: {
    title: 'ULTRA INSTINCT THEME',
    headline: 'Into <br> <span class="text-electric-purple">The Void.</span>',
    label: 'Case Study 04',
    description:
      'A neurodivergent-designed VS Code theme trilogy built to eliminate visual noise and achieve deep focus.',
    chips: [
      { text: 'Open Source', dotColor: 'bg-electric-purple' },
      { text: 'VS Code', dotColor: 'bg-blue-500' },
      { text: '2026' },
    ],
    heroImage:
      'https://images.unsplash.com/photo-1629654297299-c8506221ca97?q=80&w=1920&auto=format&fit=crop',
    heroLogo:
      'https://raw.githubusercontent.com/juanlias/ultra-instinct-theme/master/images/icon.png',
  },
  sidebar: {
    title: 'Index',
    meta: [
      { label: 'Author', value: 'Juan Lias' },
      { label: 'Type', value: 'VS Code Extension' },
      { label: 'Role', value: 'Designer & Developer' },
      { label: 'Stack', value: 'JSON, TypeScript, VS Code API' },
      { label: 'Version', value: 'v0.1.3' },
      { label: 'License', value: 'MIT Open Source' },
      { label: 'Year', value: '2026' },
    ],
    cta: 'View on GitHub',
    ctaLink: 'https://github.com/juanlias/ultra-instinct-theme',
    repoLink: 'https://github.com/juanlias/ultra-instinct-theme',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Overview',
      title: 'Project Brief',
      highlight:
        'Ultra Instinct is a VS Code theme trilogy designed from a neurodivergent perspective — an interface built to disappear, so logic can take center stage.',
      cards: [
        {
          title: 'The Void',
          text: 'Ultra-minimal design that removes cognitive friction — no unnecessary borders, no jarring contrasts, no rainbow brackets.',
        },
        {
          title: 'Three Variants',
          text: 'Sign (intense debugging), Mastered (calm daily flow), and Mastered Light (bright environments) — each tuned to a mental state.',
        },
        {
          title: 'WCAG 2.1 AA',
          text: "All contrast ratios exceed 4.5:1. High-performance coding shouldn't come at the cost of sensory overload.",
        },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Philosophy',
      label: 'Design Philosophy',
      title: 'The Void Concept',
      description:
        'As a developer with <strong>Autism and High Potential</strong>, I found standard themes cognitively overwhelming — every unnecessary border and jarring contrast broke my focus. Ultra Instinct was built to solve my own problem: a sensory-friendly interface that fades away, leaving only the code.',
      tags: [
        'Neurodivergent Design',
        'Sensory-Friendly',
        'WCAG 2.1 AA',
        'Deep Focus',
        'Flow State',
      ],
    },
    problema: {
      id: 'problema',
      menuLabel: 'Challenge',
      title: 'The Problem',
      description:
        'Standard themes are built for the average developer. For neurodivergent coders, bright colors, excessive borders, and rainbow brackets create constant sensory interruptions that break flow state and lead to cognitive fatigue.',
      stats: [
        { value: 'v0.1.3', label: 'Version', liveKey: 'version' },
        { value: '37+', label: 'Marketplace', liveKey: 'marketplaceInstalls' },
        { value: '2K+', label: 'Open VSX', liveKey: 'openVsxDownloads' },
      ],
    },
    branding: {
      id: 'branding',
      menuLabel: 'Palette',
      title: 'Theme Variants',
      description:
        'Three distinct color systems, each targeting a different mental state and coding environment.',
      palette: [
        { name: 'Sign — Deep Charcoal Void', hex: '#0d1017' },
        { name: 'Sign — Electric Blue', hex: '#82aaff' },
        { name: 'Sign — Indigo', hex: '#7986cb' },
        { name: 'Mastered — Balanced Dark Void', hex: '#141118' },
        { name: 'Mastered — Royal Purple', hex: '#a78bfa' },
        { name: 'Mastered — Silver', hex: '#94a3b8' },
        { name: 'Light — Divine Silver', hex: '#e8eaf6' },
        { name: 'Light — Aura Purple', hex: '#7c3aed' },
      ],
      typography:
        'Ultra Instinct Sign (High-intensity debugging) · Mastered (Daily development) · Mastered Light (Presentations & bright rooms)',
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Tech Stack',
      title: 'Under the Hood',
      categories: [
        { name: 'Format', items: ['JSON Theme Spec', 'VSIX Package'] },
        { name: 'Standards', items: ['WCAG 2.1 AA', 'MIT License', 'Semantic Versioning'] },
      ],
    },
    footer: {
      prev: null,
      next: { label: 'Next Case', title: 'Hyperdrive', link: '/works/hyperdrive' },
    },
  },
}
